import { cn } from "@/lib/utils"
import React from "react"

export const FormActions = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <div className={cn("pt-4 flex flex-col gap-4 items-center", "md:gap-10")}>
      {children}
    </div>
  )
}
